<template lang="pug">
  div
    div.label.basic600--text.text-uppercase {{ $t('cut_off_time') }}
    v-select.mt-2.p1(v-model="settings.cut_off_time" outlined dense background-color="basic200" hide-details :items="cutOffTimes" item-text="name" item-value="value")
      template(v-slot:append)
        eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
    div.c1.basic600--text.mt-2 {{ $t('orders_less_than_processed', { time: cutOffTimes.filter(f => f.value === settings.cut_off_time)[0].name }) }}
</template>

<script>
export default {
  name: 'CutOffTime',
  components: { },
  props: ['parentSettings'],
  data: () => ({
    cutOffTimes: [
      { name: '15 minutes before closing', value: 15 },
      { name: '30 minutes before closing', value: 30 },
      { name: '45 minutes before closing', value: 45 },
      { name: '1 hour before closing', value: 60 },
      { name: '2 hours before closing', value: 120 },
      { name: '3 hours before closing', value: 180 }
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
    }
  }),
  computed: {
    settings: {
      get () {
        return this.parentSettings
      },
      set (newValue) {
        this.$emit('update:parentSettings', newValue)
      }
    }
  },
  watch: {

  },
  mounted () {

  },
  methods: {
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "cut_off_time": "Cut-off time",
    "orders_less_than_processed": "Orders made less than {time} will be processed the next business day."
  },
  "id": {
    "cut_off_time": "Waktu Cut-off",
    "orders_less_than_processed": "Pesanan yang dibuat sebelum jam {time} akan diproses pada hari kerja berikutnya."
  }
}
</i18n>
